import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const customToastify = (type, message, time = 5000, position = "bottom-center") => {
  const options = {
    position,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  if (type == "info") {
    toast.info(message, options);
    // console.log("type,message", type, message);
  }
  else if (type == "success") toast.success(message, options);
  else if (type == "warning") toast.warning(message, options);
  else if (type == "error") toast.error(message, options);
  else toast(message, options);
};

const checkErrorMessage = (err) => {
  let errorDetails = { message: false, params: false, titles: false };
  if (
    err &&
    err["response"] &&
    err["response"]["data"] &&
    err["response"]["data"]["data"]
  ) {
    if (err["response"]["data"]["data"]["titles"])
      errorDetails.titles =
        err["response"]["data"]["data"]["titles"].join(" - ");
    if (err["response"]["data"]["data"]["params"])
      errorDetails.params = err["response"]["data"]["data"]["params"];
  } else if (
    err &&
    err["response"] &&
    err["response"]["data"] &&
    err["response"]["data"]["message"]
  ) {
    errorDetails.message = err["response"]["data"]["message"];
  } else {
    errorDetails.message = "لطفا بعدا تلاش کنید";
  }
  return errorDetails;
};

const checkResponseData = (response) => {
  let responseDetails = { success: false, message: false, data: false };
  if (response && response["data"] && response["data"]["success"]) {
    if (response["data"]["message"])
      responseDetails.message = response["data"]["message"];
    if (response["data"]["data"])
      responseDetails.data = response["data"]["data"];
    if (response["data"]["token"])
      responseDetails["token"] = response["data"]["token"];
    responseDetails.success = true;
  }
  return responseDetails;
};

const SuggestedMovies = [
  {
    "value": "لطفا تایپ کنید"
  },
  {
    "value": "برخی از نام های پیشنهادی:"
  },
  {
    "value": "Friends"
  },
  {
    "value": "Breaking Bad"
  },
  {
    "value": "Planet Earth II"
  },
  {
    "value": "Planet Earth"
  },
  {
    "value": "Band of Brothers"
  },
  {
    "value": "Chernobyl"
  },
  {
    "value": "The Wire"
  },
  {
    "value": "Avatar: The Last Airbender"
  },
  {
    "value": "Blue Planet II"
  },
  {
    "value": "The Sopranos"
  },
  {
    "value": "Cosmos: A Spacetime Odyssey"
  },
  {
    "value": "Cosmos"
  },
  {
    "value": "Our Planet"
  },
  {
    "value": "Game of Thrones"
  },
  {
    "value": "The World at War"
  },
  {
    "value": "Rick and Morty"
  },
  {
    "value": "Bluey"
  },
  {
    "value": "Fullmetal Alchemist: Brotherhood"
  },
  {
    "value": "The Last Dance"
  },
  {
    "value": "Life"
  },
  {
    "value": "The Twilight Zone"
  },
  {
    "value": "Sherlock"
  },
  {
    "value": "The Vietnam War"
  },
  {
    "value": "Batman: The Animated Series"
  },
  {
    "value": "Attack on Titan"
  },
  {
    "value": "Scam 1992: The Harshad Mehta Story"
  },
  {
    "value": "The Office"
  },
  {
    "value": "Arcane"
  },
  {
    "value": "The Blue Planet"
  },
  {
    "value": "Better Call Saul"
  },
  {
    "value": "Human Planet"
  },
  {
    "value": "Firefly"
  },
  {
    "value": "Frozen Planet"
  },
  {
    "value": "Clarkson's Farm"
  },
  {
    "value": "Death Note"
  },
  {
    "value": "Only Fools and Horses"
  },
  {
    "value": "The Civil War"
  },
  {
    "value": "Hunter x Hunter"
  },
  {
    "value": "True Detective"
  },
  {
    "value": "Seinfeld"
  },
  {
    "value": "Dekalog"
  },
  {
    "value": "The Beatles: Get Back"
  },
  {
    "value": "Persona"
  },
  {
    "value": "Fargo"
  },
  {
    "value": "Cowboy Bebop"
  },
  {
    "value": "Gravity Falls"
  },
  {
    "value": "Nathan for You"
  },
  {
    "value": "Last Week Tonight with John Oliver"
  },
  {
    "value": "Succession"
  },
  {
    "value": "When They See Us"
  },
  {
    "value": "Apocalypse: The Second World War"
  },
  {
    "value": "Africa"
  },
  {
    "value": "TVF Pitchers"
  },
  {
    "value": "Taskmaster"
  },
  {
    "value": "It's Always Sunny in Philadelphia"
  },
  {
    "value": "Monty Python's Flying Circus"
  },
  {
    "value": "As If"
  },
  {
    "value": "The West Wing"
  },
  {
    "value": "Das Boot"
  },
  {
    "value": "Curb Your Enthusiasm"
  },
  {
    "value": "One Piece"
  },
  {
    "value": "Leyla and Mecnun"
  },
  {
    "value": "Fawlty Towers"
  },
  {
    "value": "BoJack Horseman"
  },
  {
    "value": "Pride and Prejudice"
  },
  {
    "value": "Freaks and Geeks"
  },
  {
    "value": "Blackadder Goes Forth"
  },
  {
    "value": "Twin Peaks"
  },
  {
    "value": "Dragon Ball Z"
  },
  {
    "value": "Narcos"
  },
  {
    "value": "Chappelle's Show"
  },
  {
    "value": "The Last of Us"
  },
  {
    "value": "Black Mirror"
  },
  {
    "value": "I, Claudius"
  },
  {
    "value": "South Park"
  },
  {
    "value": "Over the Garden Wall"
  },
  {
    "value": "Kota Factory"
  },
  {
    "value": "Ted Lasso"
  },
  {
    "value": "Six Feet Under"
  },
  {
    "value": "Peaky Blinders"
  },
  {
    "value": "Rome"
  },
  {
    "value": "Oz"
  },
  {
    "value": "Vinland Saga"
  },
  {
    "value": "Gullak"
  },
  {
    "value": "Steins;Gate"
  },
  {
    "value": "Dark"
  },
  {
    "value": "Panchayat"
  },
  {
    "value": "The Boys"
  },
  {
    "value": "Fleabag"
  },
  {
    "value": "Battlestar Galactica"
  },
  {
    "value": "Arrested Development"
  },
  {
    "value": "The Simpsons"
  },
  {
    "value": "The Shield"
  },
  {
    "value": "Bleach: Thousand-Year Blood War"
  },
  {
    "value": "Downton Abbey"
  },
  {
    "value": "House"
  },
  {
    "value": "One Punch Man"
  },
  {
    "value": "Invincible"
  },
  {
    "value": "Severance"
  },
  {
    "value": "Mad Men"
  },
  {
    "value": "Stranger Things"
  },
  {
    "value": "Peep Show"
  },
  {
    "value": "Sarabhai V/S Sarabhai"
  },
  {
    "value": "Berserk"
  },
  {
    "value": "Star Trek: The Next Generation"
  },
  {
    "value": "The Mandalorian"
  },
  {
    "value": "Mahabharat"
  },
  {
    "value": "The Marvelous Mrs. Maisel"
  },
  {
    "value": "The Adventures of Sherlock Holmes"
  },
  {
    "value": "Friday Night Lights"
  },
  {
    "value": "Justice League Unlimited"
  },
  {
    "value": "The Grand Tour"
  },
  {
    "value": "Top Gear"
  },
  {
    "value": "Aspirants"
  },
  {
    "value": "Behzat Ç: An Ankara Detective Story"
  },
  {
    "value": "Line of Duty"
  },
  {
    "value": "The Thick of It"
  },
  {
    "value": "House of Cards"
  },
  {
    "value": "1883"
  },
  {
    "value": "This Is Us"
  },
  {
    "value": "Naruto: Shippuden"
  },
  {
    "value": "The Crown"
  },
  {
    "value": "How to with John Wilson"
  },
  {
    "value": "Atlanta"
  },
  {
    "value": "Ramayan"
  },
  {
    "value": "Father Ted"
  },
  {
    "value": "Parks and Recreation"
  },
  {
    "value": "Monster"
  },
  {
    "value": "The X-Files"
  },
  {
    "value": "Deadwood"
  },
  {
    "value": "Dexter"
  },
  {
    "value": "Critical Role"
  },
  {
    "value": "Code Geass"
  },
  {
    "value": "Primal"
  },
  {
    "value": "The Jinx: The Life and Deaths of Robert Durst"
  },
  {
    "value": "It's a Sin"
  },
  {
    "value": "The Bridge"
  },
  {
    "value": "Daredevil"
  },
  {
    "value": "Blackadder II"
  },
  {
    "value": "Adventure Time"
  },
  {
    "value": "Lonesome Dove"
  },
  {
    "value": "Yeh Meri Family"
  },
  {
    "value": "Demon Slayer: Kimetsu no Yaiba"
  },
  {
    "value": "Mindhunter"
  },
  {
    "value": "The Return of Sherlock Holmes"
  },
  {
    "value": "Gomorrah"
  },
  {
    "value": "Archer"
  },
  {
    "value": "The Offer"
  },
  {
    "value": "Haikyu!!"
  },
  {
    "value": "Mystery Science Theater 3000"
  },
  {
    "value": "Blackadder the Third"
  },
  {
    "value": "Young Justice"
  },
  {
    "value": "Poirot"
  },
  {
    "value": "Mr. Bean"
  },
  {
    "value": "Pose"
  },
  {
    "value": "Yes Minister"
  },
  {
    "value": "Dopesick"
  },
  {
    "value": "Anne with an E"
  },
  {
    "value": "Crash Landing on You"
  },
  {
    "value": "QI"
  },
  {
    "value": "Yellowstone"
  },
  {
    "value": "The Newsroom"
  },
  {
    "value": "Boardwalk Empire"
  },
  {
    "value": "Justified"
  },
  {
    "value": "The Bugs Bunny Show"
  },
  {
    "value": "The Haunting of Hill House"
  },
  {
    "value": "Justice League"
  },
  {
    "value": "Making a Murderer"
  },
  {
    "value": "El Chavo del Ocho"
  },
  {
    "value": "The Venture Bros."
  },
  {
    "value": "The Bureau"
  },
  {
    "value": "The Bear"
  },
  {
    "value": "The Queen's Gambit"
  },
  {
    "value": "Homicide: Life on the Street"
  },
  {
    "value": "Flight of the Conchords"
  },
  {
    "value": "Dragon Ball"
  },
  {
    "value": "Mr Inbetween"
  },
  {
    "value": "What We Do in the Shadows"
  },
  {
    "value": "The Eric Andre Show"
  },
  {
    "value": "Coupling"
  },
  {
    "value": "Black Sun"
  },
  {
    "value": "The Family Man"
  },
  {
    "value": "Impractical Jokers"
  },
  {
    "value": "Yes, Prime Minister"
  },
  {
    "value": "Spaced"
  },
  {
    "value": "Heartstopper"
  },
  {
    "value": "Samurai Champloo"
  },
  {
    "value": "Mr. Robot"
  },
  {
    "value": "The IT Crowd"
  },
  {
    "value": "Endeavour"
  },
  {
    "value": "Long Way Round"
  },
  {
    "value": "Rocket Boys"
  },
  {
    "value": "I'm Alan Partridge"
  },
  {
    "value": "Ezel"
  },
  {
    "value": "Formula 1: Drive to Survive"
  },
  {
    "value": "Louie"
  },
  {
    "value": "Whose Line Is It Anyway?"
  },
  {
    "value": "Mob Psycho 100"
  },
  {
    "value": "Samurai Jack"
  },
  {
    "value": "Through the Wormhole"
  },
  {
    "value": "Detectorists"
  },
  {
    "value": "Spartacus"
  },
  {
    "value": "Shameless"
  },
  {
    "value": "Sons of Anarchy"
  },
  {
    "value": "Doctor Who"
  },
  {
    "value": "Letterkenny"
  },
  {
    "value": "Neon Genesis Evangelion"
  },
  {
    "value": "Happy Valley"
  },
  {
    "value": "Brass Eye"
  },
  {
    "value": "Skam"
  },
  {
    "value": "Trailer Park Boys"
  },
  {
    "value": "North &amp; South"
  },
  {
    "value": "Extraordinary Attorney Woo"
  },
  {
    "value": "Spartacus: Gods of the Arena"
  },
  {
    "value": "The Rehearsal"
  },
  {
    "value": "Silicon Valley"
  },
  {
    "value": "Fullmetal Alchemist"
  },
  {
    "value": "Futurama"
  },
  {
    "value": "Westworld"
  },
  {
    "value": "Regular Show"
  },
  {
    "value": "Rurouni Kenshin: Trust and Betrayal"
  },
  {
    "value": "From the Earth to the Moon"
  },
  {
    "value": "Schitt's Creek"
  },
  {
    "value": "Jujutsu Kaisen"
  },
  {
    "value": "Hannibal"
  },
  {
    "value": "The Expanse"
  },
  {
    "value": "Tear Along the Dotted Line"
  },
  {
    "value": "Umbre"
  },
  {
    "value": "Derry Girls"
  },
  {
    "value": "Community"
  },
  {
    "value": "My Brilliant Friend"
  },
  {
    "value": "Wentworth"
  },
  {
    "value": "Chef's Table"
  },
  {
    "value": "Avrupa Yakasi"
  },
  {
    "value": "Your Lie in April"
  },
  {
    "value": "Gintama"
  },
  {
    "value": "Generation Kill"
  },
  {
    "value": "Cobra Kai"
  },
  {
    "value": "Alfred Hitchcock Presents"
  },
  {
    "value": "Foyle's War"
  },
  {
    "value": "The Night Of"
  },
  {
    "value": "Southland"
  },
  {
    "value": "The Knick"
  },
  {
    "value": "The Angry Video Game Nerd"
  },
  {
    "value": "RuPaul's Drag Race"
  },
  {
    "value": "Disaster Movie"
  },
  {
    "value": "Manos: The Hands of Fate"
  },
  {
    "value": "Birdemic: Shock and Terror"
  },
  {
    "value": "Superbabies: Baby Geniuses 2"
  },
  {
    "value": "The Hottie &amp; the Nottie"
  },
  {
    "value": "Kirk Cameron's Saving Christmas"
  },
  {
    "value": "House of the Dead"
  },
  {
    "value": "Son of the Mask"
  },
  {
    "value": "Epic Movie"
  },
  {
    "value": "Radhe"
  },
  {
    "value": "Battlefield Earth"
  },
  {
    "value": "Pledge This!"
  },
  {
    "value": "Alone in the Dark"
  },
  {
    "value": "Dragonball Evolution"
  },
  {
    "value": "Race 3"
  },
  {
    "value": "From Justin to Kelly"
  },
  {
    "value": "Foodfight!"
  },
  {
    "value": "Going Overboard"
  },
  {
    "value": "Turks in Space"
  },
  {
    "value": "Meet the Spartans"
  },
  {
    "value": "Gigli"
  },
  {
    "value": "Date Movie"
  },
  {
    "value": "Daniel the Wizard"
  },
  {
    "value": "Cats"
  },
  {
    "value": "Baby Geniuses"
  },
  {
    "value": "Glitter"
  },
  {
    "value": "The Human Centipede III (Final Sequence)"
  },
  {
    "value": "Cosmic Sin"
  },
  {
    "value": "Jaws: The Revenge"
  },
  {
    "value": "Troll 2"
  },
  {
    "value": "BloodRayne"
  },
  {
    "value": "Mega Shark vs. Giant Octopus"
  },
  {
    "value": "365 Days: This Day"
  },
  {
    "value": "Hobgoblins"
  },
  {
    "value": "Jeepers Creepers: Reborn"
  },
  {
    "value": "Left Behind"
  },
  {
    "value": "365 Days"
  },
  {
    "value": "The Cost of Deception"
  },
  {
    "value": "Enes Batur: Imagination or Reality?"
  },
  {
    "value": "Who's Your Caddy?"
  },
  {
    "value": "Jack and Jill"
  },
  {
    "value": "Rollerball"
  },
  {
    "value": "Santa Claus Conquers the Martians"
  },
  {
    "value": "Adipurush"
  },
  {
    "value": "Slender Man"
  },
  {
    "value": "Catwoman"
  },
  {
    "value": "Kazaam"
  },
  {
    "value": "Winnie the Pooh: Blood and Honey"
  },
  {
    "value": "Vampires Suck"
  },
  {
    "value": "The Emoji Movie"
  },
  {
    "value": "Student of the Year 2"
  },
  {
    "value": "Steel"
  },
  {
    "value": "The Open House"
  },
  {
    "value": "The Starving Games"
  },
  {
    "value": "Laxmii"
  },
  {
    "value": "Breach"
  },
  {
    "value": "Tees Maar Khan"
  },
  {
    "value": "Scary Movie V"
  },
  {
    "value": "Dumb and Dumberer: When Harry Met Lloyd"
  },
  {
    "value": "Texas Chainsaw Massacre: The Next Generation"
  },
  {
    "value": "Gunday"
  },
  {
    "value": "The Room"
  },
  {
    "value": "The Master of Disguise"
  },
  {
    "value": "Police Academy: Mission to Moscow"
  },
  {
    "value": "Bratz"
  },
  {
    "value": "Daddy Day Camp"
  },
  {
    "value": "Hercules in New York"
  },
  {
    "value": "Far Cry"
  },
  {
    "value": "Mortal Kombat: Annihilation"
  },
  {
    "value": "Feardotcom"
  },
  {
    "value": "Barb Wire"
  },
  {
    "value": "Smolensk"
  },
  {
    "value": "3 Ninjas: High Noon at Mega Mountain"
  },
  {
    "value": "Baaghi 3"
  },
  {
    "value": "Batman &amp; Robin"
  },
  {
    "value": "Fifty Shades of Black"
  },
  {
    "value": "Captain America"
  },
  {
    "value": "Spy Kids 4: All the Time in the World"
  },
  {
    "value": "Crossroads"
  },
  {
    "value": "The NeverEnding Story III"
  },
  {
    "value": "Spice World"
  },
  {
    "value": "Jaws 3-D"
  },
  {
    "value": "Superman IV: The Quest for Peace"
  },
  {
    "value": "Dungeons &amp; Dragons"
  },
  {
    "value": "The Wicker Man"
  },
  {
    "value": "Black Christmas"
  },
  {
    "value": "The Fog"
  },
  {
    "value": "Dragon Wars: D-War"
  },
  {
    "value": "Mac and Me"
  },
  {
    "value": "Bucky Larson: Born to Be a Star"
  },
  {
    "value": "Goal! III"
  },
  {
    "value": "I'll Always Know What You Did Last Summer"
  },
  {
    "value": "Piranha 3DD"
  },
  {
    "value": "The Adventures of Sharkboy and Lavagirl 3-D"
  },
  {
    "value": "I Know Who Killed Me"
  },
  {
    "value": "The Love Guru"
  },
  {
    "value": "The Hungover Games"
  },
  {
    "value": "In the Name of the King: A Dungeon Siege Tale"
  },
  {
    "value": "The Avengers"
  },
  {
    "value": "The Flintstones in Viva Rock Vegas"
  },
  {
    "value": "Reptile"
  },
  {
    "value": "The Creator"
  },
  {
    "value": "Saw X"
  },
  {
    "value": "Nowhere"
  },
  {
    "value": "The Exorcist: Believer"
  },
  {
    "value": "Argylle"
  },
  {
    "value": "No One Will Save You"
  },
  {
    "value": "The Wonderful Story of Henry Sugar"
  },
  {
    "value": "Haunted Mansion"
  },
  {
    "value": "The Equalizer 3"
  },
  {
    "value": "Killers of the Flower Moon"
  },
  {
    "value": "Barbie"
  },
  {
    "value": "The Nun II"
  },
  {
    "value": "A Haunting in Venice"
  },
  {
    "value": "Priscilla"
  },
  {
    "value": "Five Nights at Freddy's"
  },
  {
    "value": "Talk to Me"
  },
  {
    "value": "Sound of Freedom"
  },
  {
    "value": "Oppenheimer"
  },
  {
    "value": "Fair Play"
  },
  {
    "value": "The Exorcist"
  },
  {
    "value": "Meg 2: The Trench"
  },
  {
    "value": "Totally Killer"
  },
  {
    "value": "Mission: Impossible - Dead Reckoning Part One"
  },
  {
    "value": "Gran Turismo"
  },
  {
    "value": "Elemental"
  },
  {
    "value": "Expend4bles"
  },
  {
    "value": "After Everything"
  },
  {
    "value": "Leave the World Behind"
  },
  {
    "value": "Flora and Son"
  },
  {
    "value": "Jawan"
  },
  {
    "value": "X"
  },
  {
    "value": "Saw"
  },
  {
    "value": "PAW Patrol: The Mighty Movie"
  },
  {
    "value": "Dumb Money"
  },
  {
    "value": "Blue Beetle"
  },
  {
    "value": "The Blind"
  },
  {
    "value": "Poison"
  },
  {
    "value": "57 Seconds"
  },
  {
    "value": "Teenage Mutant Ninja Turtles: Mutant Mayhem"
  },
  {
    "value": "The Little Mermaid"
  },
  {
    "value": "Forgotten Love"
  },
  {
    "value": "Pet Sematary: Bloodlines"
  },
  {
    "value": "No Hard Feelings"
  },
  {
    "value": "Love at First Sight"
  },
  {
    "value": "Poor Things"
  },
  {
    "value": "Khufiya"
  },
  {
    "value": "John Wick: Chapter 4"
  },
  {
    "value": "May December"
  },
  {
    "value": "The Covenant"
  },
  {
    "value": "Love Is in the Air"
  },
  {
    "value": "Spider-Man: Across the Spider-Verse"
  },
  {
    "value": "A Million Miles Away"
  },
  {
    "value": "Bottoms"
  },
  {
    "value": "The Rat Catcher"
  },
  {
    "value": "Harry Potter and the Sorcerer's Stone"
  },
  {
    "value": "Hocus Pocus"
  },
  {
    "value": "The Swan"
  },
  {
    "value": "Fukrey 3"
  },
  {
    "value": "Past Lives"
  },
  {
    "value": "Asteroid City"
  },
  {
    "value": "Appendage"
  },
  {
    "value": "The Nun"
  },
  {
    "value": "Dungeons &amp; Dragons: Honor Among Thieves"
  },
  {
    "value": "Boiling Point"
  },
  {
    "value": "Wish"
  },
  {
    "value": "Guardians of the Galaxy Vol. 3"
  },
  {
    "value": "The Wolf of Wall Street"
  },
  {
    "value": "Indiana Jones and the Dial of Destiny"
  },
  {
    "value": "Dune"
  },
  {
    "value": "The Shawshank Redemption"
  },
  {
    "value": "Beetlejuice"
  },
  {
    "value": "Do Not Disturb"
  },
  {
    "value": "The Hunger Games: The Ballad of Songbirds and Snakes"
  },
  {
    "value": "Mean Girls"
  },
  {
    "value": "Thanksgiving"
  },
  {
    "value": "Muzzle"
  },
  {
    "value": "The Vaccine War"
  },
  {
    "value": "The Equalizer"
  },
  {
    "value": "The Toxic Avenger"
  },
  {
    "value": "Deliver Us"
  },
  {
    "value": "The Boogeyman"
  },
  {
    "value": "The Godfather"
  },
  {
    "value": "Scream"
  },
  {
    "value": "Evil Dead Rise"
  },
  {
    "value": "Saw II"
  },
  {
    "value": "Interstellar"
  },
  {
    "value": "The Flash"
  },
  {
    "value": "The Beekeeper"
  },
  {
    "value": "Halloween"
  },
  {
    "value": "The Batman"
  },
  {
    "value": "The Nightmare Before Christmas"
  },
  {
    "value": "Casper"
  },
  {
    "value": "The Meg"
  },
  {
    "value": "Fast X"
  },
  {
    "value": "Jaane Jaan"
  },
  {
    "value": "65"
  },
  {
    "value": "Strays"
  },
  {
    "value": "The Dark Knight"
  },
  {
    "value": "You have rated"
  },
  {
    "value": "The Godfather Part II"
  },
  {
    "value": "12 Angry Men"
  },
  {
    "value": "Schindler's List"
  },
  {
    "value": "The Lord of the Rings: The Return of the King"
  },
  {
    "value": "Pulp Fiction"
  },
  {
    "value": "The Lord of the Rings: The Fellowship of the Ring"
  },
  {
    "value": "The Good, the Bad and the Ugly"
  },
  {
    "value": "Forrest Gump"
  },
  {
    "value": "Fight Club"
  },
  {
    "value": "The Lord of the Rings: The Two Towers"
  },
  {
    "value": "Inception"
  },
  {
    "value": "Star Wars: Episode V - The Empire Strikes Back"
  },
  {
    "value": "The Matrix"
  },
  {
    "value": "Goodfellas"
  },
  {
    "value": "One Flew Over the Cuckoo's Nest"
  },
  {
    "value": "Se7en"
  },
  {
    "value": "It's a Wonderful Life"
  },
  {
    "value": "Seven Samurai"
  },
  {
    "value": "The Silence of the Lambs"
  },
  {
    "value": "Saving Private Ryan"
  },
  {
    "value": "City of God"
  },
  {
    "value": "Life Is Beautiful"
  },
  {
    "value": "The Green Mile"
  },
  {
    "value": "Star Wars: Episode IV - A New Hope"
  },
  {
    "value": "Terminator 2: Judgment Day"
  },
  {
    "value": "Back to the Future"
  },
  {
    "value": "Spirited Away"
  },
  {
    "value": "The Pianist"
  },
  {
    "value": "Psycho"
  },
  {
    "value": "Parasite"
  },
  {
    "value": "Gladiator"
  },
  {
    "value": "The Lion King"
  },
  {
    "value": "Léon: The Professional"
  },
  {
    "value": "American History X"
  },
  {
    "value": "The Departed"
  },
  {
    "value": "Whiplash"
  },
  {
    "value": "The Prestige"
  },
  {
    "value": "The Usual Suspects"
  },
  {
    "value": "Grave of the Fireflies"
  },
  {
    "value": "Harakiri"
  },
  {
    "value": "Casablanca"
  },
  {
    "value": "The Intouchables"
  },
  {
    "value": "Modern Times"
  },
  {
    "value": "Cinema Paradiso"
  },
  {
    "value": "Once Upon a Time in the West"
  },
  {
    "value": "Rear Window"
  },
  {
    "value": "Alien"
  },
  {
    "value": "City Lights"
  },
  {
    "value": "Apocalypse Now"
  },
  {
    "value": "Memento"
  },
  {
    "value": "Django Unchained"
  },
  {
    "value": "Raiders of the Lost Ark"
  },
  {
    "value": "WALL·E"
  },
  {
    "value": "The Lives of Others"
  },
  {
    "value": "Sunset Blvd."
  },
  {
    "value": "Paths of Glory"
  },
  {
    "value": "Avengers: Infinity War"
  },
  {
    "value": "The Shining"
  },
  {
    "value": "The Great Dictator"
  },
  {
    "value": "Witness for the Prosecution"
  },
  {
    "value": "Spider-Man: Into the Spider-Verse"
  },
  {
    "value": "Aliens"
  },
  {
    "value": "Inglourious Basterds"
  },
  {
    "value": "The Dark Knight Rises"
  },
  {
    "value": "American Beauty"
  },
  {
    "value": "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb"
  },
  {
    "value": "Oldboy"
  },
  {
    "value": "Coco"
  },
  {
    "value": "Amadeus"
  },
  {
    "value": "Toy Story"
  },
  {
    "value": "Braveheart"
  },
  {
    "value": "Avengers: Endgame"
  },
  {
    "value": "Joker"
  },
  {
    "value": "Princess Mononoke"
  },
  {
    "value": "Good Will Hunting"
  },
  {
    "value": "Once Upon a Time in America"
  },
  {
    "value": "Your Name."
  },
  {
    "value": "3 Idiots"
  },
  {
    "value": "High and Low"
  },
  {
    "value": "Singin' in the Rain"
  },
  {
    "value": "Capernaum"
  },
  {
    "value": "Requiem for a Dream"
  },
  {
    "value": "Toy Story 3"
  },
  {
    "value": "Come and See"
  },
  {
    "value": "Star Wars: Episode VI - Return of the Jedi"
  },
  {
    "value": "Eternal Sunshine of the Spotless Mind"
  },
  {
    "value": "2001: A Space Odyssey"
  },
  {
    "value": "The Hunt"
  },
  {
    "value": "Reservoir Dogs"
  },
  {
    "value": "Ikiru"
  },
  {
    "value": "Lawrence of Arabia"
  },
  {
    "value": "Citizen Kane"
  },
  {
    "value": "The Apartment"
  },
  {
    "value": "North by Northwest"
  },
  {
    "value": "Vertigo"
  },
  {
    "value": "Double Indemnity"
  },
  {
    "value": "Amélie"
  },
  {
    "value": "Scarface"
  },
  {
    "value": "Full Metal Jacket"
  },
  {
    "value": "A Clockwork Orange"
  },
  {
    "value": "Incendies"
  },
  {
    "value": "Heat"
  },
  {
    "value": "Up"
  },
  {
    "value": "Hamilton"
  },
  {
    "value": "To Kill a Mockingbird"
  },
  {
    "value": "The Sting"
  },
  {
    "value": "A Separation"
  },
  {
    "value": "Indiana Jones and the Last Crusade"
  },
  {
    "value": "Metropolis"
  },
  {
    "value": "Die Hard"
  },
  {
    "value": "Like Stars on Earth"
  },
  {
    "value": "Snatch"
  },
  {
    "value": "Bicycle Thieves"
  },
  {
    "value": "L.A. Confidential"
  },
  {
    "value": "Taxi Driver"
  },
  {
    "value": "1917"
  },
  {
    "value": "Downfall"
  },
  {
    "value": "Dangal"
  },
  {
    "value": "For a Few Dollars More"
  },
  {
    "value": "Batman Begins"
  },
  {
    "value": "Top Gun: Maverick"
  },
  {
    "value": "Some Like It Hot"
  },
  {
    "value": "The Kid"
  },
  {
    "value": "The Father"
  },
  {
    "value": "Green Book"
  },
  {
    "value": "All About Eve"
  },
  {
    "value": "Judgment at Nuremberg"
  },
  {
    "value": "The Truman Show"
  },
  {
    "value": "There Will Be Blood"
  },
  {
    "value": "Casino"
  },
  {
    "value": "Ran"
  },
  {
    "value": "Shutter Island"
  },
  {
    "value": "Pan's Labyrinth"
  },
  {
    "value": "The Sixth Sense"
  },
  {
    "value": "Unforgiven"
  },
  {
    "value": "Jurassic Park"
  },
  {
    "value": "A Beautiful Mind"
  },
  {
    "value": "The Treasure of the Sierra Madre"
  },
  {
    "value": "Yojimbo"
  },
  {
    "value": "No Country for Old Men"
  },
  {
    "value": "Kill Bill: Vol. 1"
  },
  {
    "value": "Monty Python and the Holy Grail"
  },
  {
    "value": "The Thing"
  },
  {
    "value": "The Great Escape"
  },
  {
    "value": "Rashomon"
  },
  {
    "value": "Finding Nemo"
  },
  {
    "value": "The Elephant Man"
  },
  {
    "value": "Chinatown"
  },
  {
    "value": "Howl's Moving Castle"
  },
  {
    "value": "Gone with the Wind"
  },
  {
    "value": "Dial M for Murder"
  },
  {
    "value": "V for Vendetta"
  },
  {
    "value": "Raging Bull"
  },
  {
    "value": "Spider-Man: No Way Home"
  },
  {
    "value": "Lock, Stock and Two Smoking Barrels"
  },
  {
    "value": "The Secret in Their Eyes"
  },
  {
    "value": "Prisoners"
  },
  {
    "value": "Inside Out"
  },
  {
    "value": "Three Billboards Outside Ebbing, Missouri"
  },
  {
    "value": "The Bridge on the River Kwai"
  },
  {
    "value": "Trainspotting"
  },
  {
    "value": "Warrior"
  },
  {
    "value": "Gran Torino"
  },
  {
    "value": "Catch Me If You Can"
  },
  {
    "value": "My Neighbor Totoro"
  },
  {
    "value": "Million Dollar Baby"
  },
  {
    "value": "Klaus"
  },
  {
    "value": "Harry Potter and the Deathly Hallows: Part 2"
  },
  {
    "value": "Children of Heaven"
  },
  {
    "value": "Blade Runner"
  },
  {
    "value": "12 Years a Slave"
  },
  {
    "value": "Before Sunrise"
  },
  {
    "value": "The Grand Budapest Hotel"
  },
  {
    "value": "The Gold Rush"
  },
  {
    "value": "Ben-Hur"
  },
  {
    "value": "Gone Girl"
  },
  {
    "value": "Barry Lyndon"
  },
  {
    "value": "On the Waterfront"
  },
  {
    "value": "Hacksaw Ridge"
  },
  {
    "value": "In the Name of the Father"
  },
  {
    "value": "Memories of Murder"
  },
  {
    "value": "The General"
  },
  {
    "value": "The Deer Hunter"
  },
  {
    "value": "Wild Strawberries"
  },
  {
    "value": "The Wages of Fear"
  },
  {
    "value": "The Third Man"
  },
  {
    "value": "Wild Tales"
  },
  {
    "value": "Sherlock Jr."
  },
  {
    "value": "Dead Poets Society"
  },
  {
    "value": "Mad Max: Fury Road"
  },
  {
    "value": "Mr. Smith Goes to Washington"
  },
  {
    "value": "Monsters, Inc."
  },
  {
    "value": "Jaws"
  },
  {
    "value": "How to Train Your Dragon"
  },
  {
    "value": "Mary and Max"
  },
  {
    "value": "The Seventh Seal"
  },
  {
    "value": "Room"
  },
  {
    "value": "Ford v Ferrari"
  },
  {
    "value": "The Big Lebowski"
  },
  {
    "value": "Tokyo Story"
  },
  {
    "value": "Ratatouille"
  },
  {
    "value": "Rocky"
  },
  {
    "value": "Hotel Rwanda"
  },
  {
    "value": "The Passion of Joan of Arc"
  },
  {
    "value": "Logan"
  },
  {
    "value": "Spotlight"
  },
  {
    "value": "Platoon"
  },
  {
    "value": "The Terminator"
  },
  {
    "value": "Jai Bhim"
  },
  {
    "value": "Before Sunset"
  },
  {
    "value": "Rush"
  },
  {
    "value": "Network"
  },
  {
    "value": "Stand by Me"
  },
  {
    "value": "The Best Years of Our Lives"
  },
  {
    "value": "La haine"
  },
  {
    "value": "The Wizard of Oz"
  },
  {
    "value": "Pirates of the Caribbean: The Curse of the Black Pearl"
  },
  {
    "value": "Into the Wild"
  },
  {
    "value": "The Incredibles"
  },
  {
    "value": "To Be or Not to Be"
  },
  {
    "value": "Hachi: A Dog's Tale"
  },
  {
    "value": "The Handmaiden"
  },
  {
    "value": "Groundhog Day"
  },
  {
    "value": "The Battle of Algiers"
  },
  {
    "value": "The Grapes of Wrath"
  },
  {
    "value": "My Father and My Son"
  },
  {
    "value": "Amores Perros"
  },
  {
    "value": "Rebecca"
  },
  {
    "value": "The Sound of Music"
  },
  {
    "value": "Cool Hand Luke"
  },
  {
    "value": "Pather Panchali"
  },
  {
    "value": "It Happened One Night"
  },
  {
    "value": "The Iron Giant"
  },
  {
    "value": "The Help"
  },
  {
    "value": "The 400 Blows"
  },
  {
    "value": "Life of Brian"
  },
  {
    "value": "Aladdin"
  },
  {
    "value": "Dances with Wolves"
  },
  {
    "value": "Gen V"
  },
  {
    "value": "Ahsoka"
  },
  {
    "value": "Sex Education"
  },
  {
    "value": "Loki"
  },
  {
    "value": "The Continental: From the World of John Wick"
  },
  {
    "value": "The Wheel of Time"
  },
  {
    "value": "Only Murders in the Building"
  },
  {
    "value": "American Horror Story"
  },
  {
    "value": "Suits"
  },
  {
    "value": "Found"
  },
  {
    "value": "The Morning Show"
  },
  {
    "value": "The Long Shadow"
  },
  {
    "value": "Castlevania: Nocturne"
  },
  {
    "value": "Our Flag Means Death"
  },
  {
    "value": "The Walking Dead"
  },
  {
    "value": "Lupin"
  },
  {
    "value": "Billions"
  },
  {
    "value": "Grey's Anatomy"
  },
  {
    "value": "The Walking Dead: Daryl Dixon"
  },
  {
    "value": "Top Boy"
  },
  {
    "value": "Supernatural"
  },
  {
    "value": "Virgin River"
  },
  {
    "value": "The Irrational"
  },
  {
    "value": "Wilderness"
  },
  {
    "value": "Dear Child"
  },
  {
    "value": "Young Sheldon"
  },
  {
    "value": "Rose Red"
  },
  {
    "value": "NCIS"
  },
  {
    "value": "Law &amp; Order: Special Victims Unit"
  },
  {
    "value": "Foundation"
  },
  {
    "value": "The Rookie"
  },
  {
    "value": "Naked Attraction"
  },
  {
    "value": "Invasion"
  },
  {
    "value": "Criminal Minds"
  },
  {
    "value": "Gilmore Girls"
  },
  {
    "value": "The Big Bang Theory"
  },
  {
    "value": "The Fall of the House of Usher"
  },
  {
    "value": "Special Ops: Lioness"
  },
  {
    "value": "The Witcher"
  },
  {
    "value": "The Pacific"
  },
  {
    "value": "Chucky"
  },
  {
    "value": "Brassic"
  },
  {
    "value": "Outlander"
  },
  {
    "value": "Modern Family"
  },
  {
    "value": "Castlevania"
  },
  {
    "value": "Beckham"
  },
  {
    "value": "True Blood"
  },
  {
    "value": "House of the Dragon"
  },
  {
    "value": "Silo"
  },
  {
    "value": "Bones"
  },
  {
    "value": "Star Wars Rebels"
  },
  {
    "value": "Quantum Leap"
  },
  {
    "value": "The Blacklist"
  },
  {
    "value": "Midsomer Murders"
  },
  {
    "value": "Star Wars: The Clone Wars"
  },
  {
    "value": "The Vampire Diaries"
  },
  {
    "value": "Magnum P.I."
  },
  {
    "value": "Wednesday"
  },
  {
    "value": "Vikings"
  },
  {
    "value": "Adventure Time: Fionna &amp; Cake"
  },
  {
    "value": "Harlan Coben's Shelter"
  },
  {
    "value": "Lost"
  },
  {
    "value": "Masters of the Air"
  },
  {
    "value": "The Changeling"
  },
  {
    "value": "The Red Shoes"
  },
  {
    "value": "All Quiet on the Western Front"
  },
  {
    "value": "Paper Moon"
  },
  {
    "value": "Inherit the Wind"
  },
  {
    "value": "The Man Who Shot Liberty Valance"
  },
  {
    "value": "Paris, Texas"
  },
  {
    "value": "White Heat"
  },
  {
    "value": "Ace in the Hole"
  },
  {
    "value": "Gandhi"
  },
  {
    "value": "Scent of a Woman"
  },
  {
    "value": "Beauty and the Beast"
  },
  {
    "value": "A Woman Under the Influence"
  },
  {
    "value": "Guardians of the Galaxy"
  },
  {
    "value": "Soul"
  },
  {
    "value": "Roman Holiday"
  },
  {
    "value": "Dog Day Afternoon"
  },
  {
    "value": "Kill Bill: Vol. 2"
  },
  {
    "value": "Lion"
  },
  {
    "value": "JFK"
  },
  {
    "value": "Song of the Sea"
  },
  {
    "value": "Donnie Darko"
  },
  {
    "value": "The Princess Bride"
  },
  {
    "value": "Rosemary's Baby"
  },
  {
    "value": "The Shop Around the Corner"
  },
  {
    "value": "Anatomy of a Murder"
  },
  {
    "value": "Slumdog Millionaire"
  },
  {
    "value": "Brief Encounter"
  },
  {
    "value": "The Imitation Game"
  },
  {
    "value": "Butch Cassidy and the Sundance Kid"
  },
  {
    "value": "La La Land"
  },
  {
    "value": "What Ever Happened to Baby Jane?"
  },
  {
    "value": "Casino Royale"
  },
  {
    "value": "The Bourne Ultimatum"
  },
  {
    "value": "Magnolia"
  },
  {
    "value": "The King's Speech"
  },
  {
    "value": "Rain Man"
  },
  {
    "value": "Black Swan"
  },
  {
    "value": "Sin City"
  },
  {
    "value": "The Message"
  },
  {
    "value": "The Martian"
  },
  {
    "value": "The Legend of 1900"
  },
  {
    "value": "The Pursuit of Happyness"
  },
  {
    "value": "Dogville"
  },
  {
    "value": "Kind Hearts and Coronets"
  },
  {
    "value": "Zootopia"
  },
  {
    "value": "Secrets &amp; Lies"
  },
  {
    "value": "Who's Afraid of Virginia Woolf?"
  },
  {
    "value": "Sweet Smell of Success"
  },
  {
    "value": "The Graduate"
  },
  {
    "value": "The Straight Story"
  },
  {
    "value": "Planet of the Apes"
  },
  {
    "value": "The Night of the Hunter"
  },
  {
    "value": "12 Monkeys"
  },
  {
    "value": "Blood Diamond"
  },
  {
    "value": "Papillon"
  },
  {
    "value": "Blade Runner 2049"
  },
  {
    "value": "Her"
  }
];
export { customToastify, checkErrorMessage, checkResponseData, SuggestedMovies };
